"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=interface.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/g2/lib/plot/interface.js
// module id = 835
// module chunks = 37